import { Navigate, RouteObject } from 'react-router-dom';
import { AppWrapper } from '../layout/AppWrapper';
import { ProtectedRoute } from '../layout/ProtectedRoute';
import { RequireAffiliateApproved } from '../layout/RequireAffiliateApproved';
import AffiliateProgramPage from '../pages/app/AffiliateProgramPage';
import ClientsPage from '../pages/app/ClientsPage';
import DashboardPage from '../pages/app/DashboardPage';
import EarningsPage from '../pages/app/EarningsPage';
import ProfilePage from '../pages/app/ProfilePage';
import ReferralPage from '../pages/app/ReferralPage';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import VerifyEmailPending from '../pages/auth/VerifyEmailPending';

export const routes: RouteObject[] = [
  // Root redirect
  {
    path: '/',
    element: <Navigate to="/app" replace />,
  },

  // Auth routes
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/verify-email-pending',
    element: <VerifyEmailPending />,
  },

  // Main app routes (authenticated portal users)
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <AppWrapper />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'affiliate-program',
        element: <AffiliateProgramPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      // Dashboard pages require an APPROVED affiliate account
      {
        element: <RequireAffiliateApproved />,
        children: [
          {
            path: '',
            element: <DashboardPage />,
          },
          {
            path: 'referral',
            element: <ReferralPage />,
          },
          {
            path: 'earnings',
            element: <EarningsPage />,
          },
          {
            path: 'clients',
            element: <ClientsPage />,
          },
        ],
      },
    ],
  },

  // 404 fallback
  {
    path: '*',
    element: <Navigate to="/app" replace />,
  },
];
